import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import UnderwritingsReportComponent from './underwritings.reports.component';
import Reports from './reports';
// import UnderwritingsApproval from './underwritingsApproval.component';

export default function UnderwritingsReportsRouterComponent(props) {
  const { path } = useRouteMatch();
  return (
    <React.Fragment>
      <Switch>
        {/* <Route exact path={`${path}/underwritingsapprovallist`} component={UnderwritingsApproval} /> */}
        <Route exact path={path}>
          {' '}
          <UnderwritingsReportComponent />{' '}
        </Route>
        {/* <Route exact path={`${path}/member`}>
          {' '}
          <MembersComponent />{' '}
        </Route> */}
        <Route exact path={`${path}/:id`}>
          {' '}
          <Reports />{' '}
        </Route>
        {/* <Route exact path="/report/underwritingsapprovallist" component={<UnderwritingsApproval />} /> */}
      </Switch>
    </React.Fragment>
  );
}
